import React from "react"
import PropTypes from "prop-types"
import Nav from "./nav";

const HeaderThird = ({pageContext}) => {

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white primary--nav">
            <Nav pageContext={pageContext}/>
        </nav>
    )
};

HeaderThird.propTypes = {
    siteTitle: PropTypes.string,
};

HeaderThird.defaultProps = {
    siteTitle: ``,
};

export default HeaderThird
